export * from './employee-average-bonus/employee-average-bonus.component';
export * from './employee-average-expenses/employee-average-expenses.component';
export * from './employee-average-income/employee-average-income.component';
export * from './employee-bonus/employee-bonus.component';
export * from './employee-work-status/employee-work-status.component';